import { resolveLegalReturn } from "../utils/legalFlowReturn";

export default function useLegalReturnLink(location) {
  return resolveLegalReturn(location);
}
